import React, { useState } from 'react';
import Campo from './Campo';

const normalizzaCampo = (c) => ({
  nome: c.nome || c.categoria || '',
  descrizione: c.descrizione || (Array.isArray(c.options) ? c.options.join(', ') : ''),
  traduzioni: Array.isArray(c.traduzioni) ? c.traduzioni : [],
});

const CampiMenu = ({ onCampiChange, initialCampi = [], lingue = [] }) => {
  const [campi, setCampi] = useState(
    initialCampi.length > 0
      ? initialCampi.map(normalizzaCampo)
      : [{ nome: '', descrizione: '', traduzioni: [] }]
  );

  const propagate = (nuoviCampi) => {
    setCampi(nuoviCampi);
    onCampiChange(nuoviCampi);
  };

  const aggiungiCampo = () => {
    propagate([...campi, { nome: '', descrizione: '', traduzioni: [] }]);
  };

  const handleRemoveCampo = (index) => {
    const nuoviCampi = [...campi];
    nuoviCampi.splice(index, 1);
    propagate(nuoviCampi);
  };

  const handleCampoChange = (index, e) => {
    const { name, value } = e.target;
    const nuoviCampi = [...campi];
    nuoviCampi[index] = { ...nuoviCampi[index], [name]: value };
    propagate(nuoviCampi);
  };

  const handleTraduzioneChange = (index, codiceLingua, field, value) => {
    const nuoviCampi = [...campi];
    const campo = { ...nuoviCampi[index] };
    const traduzioni = Array.isArray(campo.traduzioni) ? [...campo.traduzioni] : [];
    const idx = traduzioni.findIndex((t) => t.codiceLingua === codiceLingua);
    if (idx >= 0) {
      traduzioni[idx] = { ...traduzioni[idx], [field]: value };
    } else {
      traduzioni.push({ codiceLingua, nome: '', descrizione: '', [field]: value });
    }
    campo.traduzioni = traduzioni;
    nuoviCampi[index] = campo;
    propagate(nuoviCampi);
  };

  return (
    <div>
      {campi.map((campo, index) => (
        <Campo
          key={index}
          nome={campo.nome}
          descrizione={campo.descrizione}
          traduzioni={campo.traduzioni}
          lingue={lingue}
          onChange={(e) => handleCampoChange(index, e)}
          onTraduzioneChange={(codice, field, value) =>
            handleTraduzioneChange(index, codice, field, value)
          }
          onRemove={() => handleRemoveCampo(index)}
        />
      ))}
      <button type="button" onClick={aggiungiCampo}>Aggiungi portate</button>
    </div>
  );
};

export default CampiMenu;
